import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"content-header\"><div class=\"container-fluid\"><div class=\"row mb-2\"><div class=\"col-sm-6\"><h1>Produtos</h1></div><div class=\"col-sm-6\"><ol class=\"breadcrumb float-sm-right\"><li class=\"breadcrumb-item\"><a href=\"#\">Home</a></li><li class=\"breadcrumb-item active\">Produtos</li></ol></div></div></div></section>", 1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "card-body row" }
const _hoisted_11 = { class: "form-group col-12 col-md-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "enabled" }, "Situação:    ", -1)
const _hoisted_13 = { class: "form-group col-12 col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nome:    ", -1)
const _hoisted_15 = { class: "form-group col-12 col-md-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "time" }, "Preço:    ", -1)
const _hoisted_17 = { class: "form-group col-12 col-md-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "type_description" }, "Tipo de produto:    ", -1)
const _hoisted_19 = { class: "form-group col-12" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Observações:    ", -1)
const _hoisted_21 = { class: "card-footer text-center" }
const _hoisted_22 = { class: "btn-group" }
const _hoisted_23 = { class: "card card-success card-outline" }
const _hoisted_24 = { class: "card-header" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-address-card" }),
  /*#__PURE__*/_createTextVNode(" Tipos de mídia ")
], -1)
const _hoisted_26 = { class: "card-tools" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "card-body row body-table-list" }
const _hoisted_30 = { class: "table-list" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Tag"),
  /*#__PURE__*/_createElementVNode("th", null, "Tipo"),
  /*#__PURE__*/_createElementVNode("th", null, "Tempo"),
  /*#__PURE__*/_createElementVNode("th", null, "Tamanho máx"),
  /*#__PURE__*/_createElementVNode("th", null, "Observações"),
  /*#__PURE__*/_createElementVNode("th", null, "Situação"),
  /*#__PURE__*/_createElementVNode("th")
], -1)
const _hoisted_32 = {
  class: "table-button-container",
  style: {"text-align":"center"}
}
const _hoisted_33 = { class: "btn-group" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block","padding-right":"15px"}
}
const _hoisted_38 = { class: "modal-dialog modal-lg" }
const _hoisted_39 = { class: "modal-content" }
const _hoisted_40 = { class: "modal-header" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h4", { class: "modal-title" }, "Incluir tipo de mídia", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "modal-body body-table-list" }
const _hoisted_45 = { class: "table-list table-list-modal" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th"),
  /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"50px"} }, "ID"),
  /*#__PURE__*/_createElementVNode("th", null, "Tag"),
  /*#__PURE__*/_createElementVNode("th", null, "Tempo"),
  /*#__PURE__*/_createElementVNode("th", null, "Tipo"),
  /*#__PURE__*/_createElementVNode("th", null, "Tamanho Máx"),
  /*#__PURE__*/_createElementVNode("th", null, "Observações")
], -1)
const _hoisted_47 = { style: {"text-align":"center"} }
const _hoisted_48 = ["id", "value", "disabled"]
const _hoisted_49 = { style: {"text-align":"center"} }
const _hoisted_50 = { class: "modal-footer justify-content-between" }
const _hoisted_51 = {
  key: 1,
  class: "modal fade show",
  style: {"display":"block","padding-right":"15px"}
}
const _hoisted_52 = { class: "modal-dialog" }
const _hoisted_53 = { class: "modal-content bg-danger" }
const _hoisted_54 = { class: "modal-header" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h4", { class: "modal-title" }, "Remover tipo de mídia", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { class: "modal-body" }
const _hoisted_59 = { class: "modal-footer justify-content-between" }
const _hoisted_60 = {
  key: 2,
  class: "modal-backdrop fade show"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, "Produto | " + _toDisplayString(_ctx.id), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: "Voltar"
              }, _hoisted_9)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", {
                class: _normalizeClass(["badge", {
              'bg-success': _ctx.row.enabled,
              'bg-danger': !_ctx.row.enabled
            }])
              }, _toDisplayString(_ctx.row.enabled ? 'Ativo' : 'Inativo'), 3)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createTextVNode(" " + _toDisplayString(_ctx.row.name), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createTextVNode(" " + _toDisplayString(_ctx.row.price), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createTextVNode(" " + _toDisplayString(_ctx.row.product_type_description), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createTextVNode(" " + _toDisplayString(_ctx.row.description), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-info",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.goBack()))
              }, "Voltar"),
              (_ctx.hasPermission('edit'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    id: "editarButton",
                    class: "btn btn-warning",
                    onClick: _cache[2] || (_cache[2] = $event => (_ctx.edit()))
                  }, "Editar"))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              (_ctx.hasPermission('edit'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    id: "newButton",
                    class: "btn btn-block btn-primary btn-xs",
                    onClick: _cache[3] || (_cache[3] = $event => (_ctx.newTypeMedia())),
                    style: {"width":"33px"},
                    "data-tooltip": "Novo"
                  }, _hoisted_28))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("table", _hoisted_30, [
              _hoisted_31,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productMediaTypes, (i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i.id_type_media
                }, [
                  _createElementVNode("td", null, _toDisplayString(i.type_media_tag), 1),
                  _createElementVNode("td", null, _toDisplayString(i.type_media_document_type), 1),
                  _createElementVNode("td", null, _toDisplayString(i.type_media_time), 1),
                  _createElementVNode("td", null, _toDisplayString(i.type_media_max_file_size), 1),
                  _createElementVNode("td", null, _toDisplayString(i.type_media_description), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", {
                  'bg-success': i.enabled,
                  'bg-danger': !i.enabled
                }])
                    }, _toDisplayString(i.enabled ? 'Ativo' : 'Inativo'), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        (_ctx.hasPermission('edit'))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: $event => (_ctx.deleteTypeMedia(i.id_type_media, i.type_media_tag)),
                              class: "btn btn-xs btn-danger",
                              title: "Remover"
                            }, _hoisted_36, 8, _hoisted_34))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      (_ctx.showInsertTypeMedia)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Fechar",
                    onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, _hoisted_43)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("table", _hoisted_45, [
                    _hoisted_46,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaTypes, (i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: i.id
                      }, [
                        _createElementVNode("td", _hoisted_47, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.mediaTypesSelected) = $event)),
                            id: i.id,
                            value: i.id,
                            disabled: _ctx.typeMediaAlreadyAdded(i.id)
                          }, null, 8, _hoisted_48), [
                            [_vModelCheckbox, _ctx.mediaTypesSelected]
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_49, _toDisplayString(i.id), 1),
                        _createElementVNode("td", null, _toDisplayString(i.tag), 1),
                        _createElementVNode("td", null, _toDisplayString(i.time) + " s", 1),
                        _createElementVNode("td", null, _toDisplayString(i.type_description), 1),
                        _createElementVNode("td", null, _toDisplayString(i.max_file_size), 1),
                        _createElementVNode("td", null, _toDisplayString(i.description), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-default",
                    onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, "Fechar"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.saveTypeMedia && _ctx.saveTypeMedia(...args)))
                  }, "Gravar")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showDeleteTypeMedia)
        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _hoisted_55,
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Fechar",
                    onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, _hoisted_57)
                ]),
                _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.msgDeleteTypeMedia), 1),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-light",
                    onClick: _cache[9] || (_cache[9] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, "Fechar"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-light",
                    onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.deleteTypeMediaConfirm && _ctx.deleteTypeMediaConfirm(...args)))
                  }, "Confirmar")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showInsertTypeMedia || _ctx.showDeleteTypeMedia)
        ? (_openBlock(), _createElementBlock("div", _hoisted_60))
        : _createCommentVNode("", true)
    ])
  ], 64))
}